import React, { useState } from 'react'
import moment from 'moment'
import {
  DcButton,
  DcDiv,
  DcDropDown,
  DcFlexBox,
  DcInput,
  DcText,
  PixelFactoryContext,
} from 'pixel-base'
import styled from 'styled-components'

import { updateVendors } from 'utils/api-routes.util'
import { IPixelFactory } from '../../../../../../decl.d'
const UpdateVendors = (props: any) => {
  const { handleClose, selectedVendor, contract, businessType } = props

  const [readyForSubmit, setReadyForSubmit] = useState(false)
  const [data, setData] = React.useState({
    name: '',
    phone: '',
    city: '',
    contact_person: '',
    contract_start_date: '',
    term_id: '',
    business_type_id: '',
    address: '',
  })
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const { showSuccess, showFailure, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)

  const updateAllVendors = () => {
    const popupData = {
      name: data.name,
      phone: data.phone,
      city: data.city,
      contact_person: data.contact_person,
      contract_start_date: data.contract_start_date,
      term_id: data.term_id,
      address: data.address,
    }

    updateVendors(popupData, selectedVendor.id).subscribe((res: any) => {
      if (res.response.data) {
        showSuccess('Successfully updated')

        handleClose(res.response.data, 'update')
        hidePageLoader()
      } else {
        if (res.response.error && res.response.field) {
          setError({
            error: res.response.error,
            field: res.response.field,
          })
        } else {
          showFailure(res.response.error)
        }
        hidePageLoader()
      }
    })
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    updateAllVendors()
  }
  React.useEffect(() => {
    setData({
      ...data,
      ...selectedVendor,
      contract_start_date: selectedVendor.business_contract_start_date,
    })
    setTimeout(() => {
      setReadyForSubmit(true)
    }, 1000)
  }, [selectedVendor])

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Name
          </DcText>
          <DcInput
            error={
              error.field === 'Name' && error.error !== '' ? error.error : null
            }
            required
            type={'text'}
            name={'Name'}
            placeholder={'Name'}
            value={data.name}
            onChange={(e) => setData({ ...data, name: e.target.value })}
          />
        </DcDiv>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Phone
          </DcText>
          <DcInput
            error={
              error.field === 'phone' && error.error !== '' ? error.error : null
            }
            required={false}
            type={'text'}
            name={'phone'}
            placeholder={'Phone'}
            value={data.phone}
            onChange={(e) => setData({ ...data, phone: e.target.value })}
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            City
          </DcText>
          <DcInput
            error={
              error.field === 'city' && error.error !== '' ? error.error : null
            }
            required
            type={'text'}
            name={'city'}
            placeholder={'City'}
            value={data.city}
            onChange={(e) => setData({ ...data, city: e.target.value })}
          />
        </DcDiv>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Contact Person
          </DcText>
          <DcInput
            error={
              error.field === 'contact_person' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'text'}
            name={'contact_person'}
            placeholder={'Contact Person'}
            value={data.contact_person}
            onChange={(e) =>
              setData({ ...data, contact_person: e.target.value })
            }
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Contract Start Date
          </DcText>
          <DcInput
            error={
              error.field === 'contract_start_date' && error.error !== ''
                ? error.error
                : null
            }
            required
            as={'datePicker'}
            name={'contract_start_date'}
            placeholder={'Contract Start Date'}
            value={
              data.contract_start_date
                ? moment(data.contract_start_date).format(
                    'YYYY-MM-DD 19:14:SS.SSSSSS',
                  )
                : new Date()
            }
            onChange={(e) =>
              setData({
                ...data,
                contract_start_date: moment(e).format('YYYY-MM-DD'),
              })
            }
          />
        </DcDiv>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Select Contract Term
          </DcText>
          <DcDropDown
            error={
              error.field === 'term_id' && error.error !== ''
                ? error.error
                : null
            }
            placeholder={'Select Contract Term'}
            options={[
              {
                contract_details: 'Select Contract Term',
                term_id: '',
              },
              ...contract,
            ].map((p) => {
              return {
                label: p.contract_details,
                value: p.term_id,
              }
            })}
            name={'term_id'}
            value={data.term_id}
            onChange={(e) => {
              setData({
                ...data,
                term_id: e.target.value,
                contract_start_date:
                  data.term_id === null
                    ? moment().format('YYYY-MM-DD')
                    : data.contract_start_date,
              })
            }}
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Vendor
          </DcText>
          <DcDropDown
            error={
              error.field === 'business_type' && error.error !== ''
                ? error.error
                : null
            }
            options={[
              {
                name: 'Select Business Type',
                id: '',
              },
              ...businessType,
            ].map((p) => {
              return {
                label: p.name,
                value: p.id,
              }
            })}
            disabled={true}
            requierd={false}
            placeholder={'Vendor'}
            name={'business_type'}
            value={data.business_type_id}
            onChange={(e) =>
              setData({ ...data, business_type_id: e.target.value })
            }
          />
        </DcDiv>
      </FormGroup>
      <FormGroup>
        <DcDiv
          width="100%"
          height="auto"
          style={{
            display: 'flex',

            flexDirection: 'column',
            alignItems: 'flexStart',
          }}
        >
          <DcText
            style={{
              textAlign: 'left',

              color: '#2e314a',
              fontSize: '.875rem',
              fontWeight: '500',
              marginBottom: '.5rem',
            }}
          >
            Address
          </DcText>
          <DcInput
            error={
              error.field === 'addressa' && error.error !== ''
                ? error.error
                : null
            }
            required
            as={'textarea'}
            name={'address'}
            placeholder={'Address'}
            value={data.address}
            onChange={(e) => setData({ ...data, address: e.target.value })}
          />
        </DcDiv>
      </FormGroup>
      <DcFlexBox height="auto" justifyContent="flex-end">
        <DcButton size="sm" disabled={!readyForSubmit} type={'submit'}>
          Update
        </DcButton>
      </DcFlexBox>
    </Form>
  )
}
const Form = styled.form`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;

  align-items: flex-start;
  align-content: flex-start;
  gap: 10px;
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
export default UpdateVendors
